/**
 * General Services class
 */
import RestClient from '../Client/RestClient'
import Configuration from '../Api/Configuration'

const { User_EndPoints, Workspace_EndPoints } = Configuration

class UserServices {
  static getProfileData (header) {
    return RestClient.getRequest(User_EndPoints.profile, header, true)
  }

  static getCountries (header) {
    return RestClient.getRequest(User_EndPoints.countries, header)
  }

  static getGovernments (country, header) {
    return RestClient.getRequest(`/country/${country}/government`, header)
  }

  static getCities (government, header) {
    return RestClient.getRequest(`/government/${government}/city`, header)
  }

  static getUsers (header) {
    return RestClient.getRequest(Workspace_EndPoints.users, header, true)
  }

  static exportUsers (header) {
    return RestClient.getRequest(Workspace_EndPoints.exportUsers, header, true)
  }

  static activateDeactivateUser (userId, data, header, setFormLoading) {
    return RestClient.patchRequest(Workspace_EndPoints.users + `/${userId}`, data, header, setFormLoading, null, null, true)
  }

  static sendResetPasswordOTP (userId, header) {
    return RestClient.getRequest(Workspace_EndPoints.users + `/${userId}/reset-password`, header, true)
  }

  static getUserProfileData (userId, header) {
    return RestClient.getRequest(Workspace_EndPoints.users + `/${userId}`, header, true)
  }

  static updateUserProfileData (userId, data, header, setFormLoading, setFailure, FormikActions) {
    return RestClient.putRequest(Workspace_EndPoints.users + `/${userId}`, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static getUserCompanies (userId, header) {
    return RestClient.getRequest(`${Workspace_EndPoints.users}/${userId}/company`, header, true)
  }

  static activateDeactivateUserCompany (userId, cid, data, header, setFormLoading) {
    return RestClient.patchRequest(`${Workspace_EndPoints.users}/${userId}/company/${cid}`, data, header, setFormLoading, null, null, true)
  }

  static getPaymentClaims (header) {
    return RestClient.getRequest(Workspace_EndPoints.paymentClaims, header, true)
  }

  static exportPaymentClaims (header) {
    return RestClient.getRequest(Workspace_EndPoints.exportPaymentClaims, header, true)
  }

  static getPaymentRequests (header) {
    return RestClient.getRequest(Workspace_EndPoints.paymentRequests, header, true)
  }

  static exportPaymentRequests (header) {
    return RestClient.getRequest(Workspace_EndPoints.exportPaymentRequests, header, true)
  }

  static getPaymentReceipts (header) {
    return RestClient.getRequest(Workspace_EndPoints.paymentReceipts, header, true)
  }

  static exportPaymentReceipts (header) {
    return RestClient.getRequest(Workspace_EndPoints.exportPaymentReceipts, header, true)
  }

  static getActivityLog (header) {
    return RestClient.getRequest(Workspace_EndPoints.activityLog, header, true)
  }

  static getPermissions (header) {
    return RestClient.getRequest(Workspace_EndPoints.permissions, header, true)
  }

  static getRoles (header) {
    return RestClient.getRequest(Workspace_EndPoints.roles, header, true)
  }

  static getRoleData (roleId, header) {
    return RestClient.getRequest(Workspace_EndPoints.roles + `/${roleId}`, header, true)
  }

  static updateRole (roleId, data, header, setFormLoading, setFailure, FormikActions) {
    return RestClient.putRequest(Workspace_EndPoints.roles + `/${roleId}`, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static submitRole (roleId, isEdit, data, header, setFormLoading, setFailure, FormikActions) {
    return !!isEdit ? RestClient.putRequest(Workspace_EndPoints.roles + `/${roleId}`, data, header, setFormLoading, setFailure, FormikActions, true)
      : RestClient.postRequest(Workspace_EndPoints.roles, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static deleteRole (roleId, header, setFormLoading) {
    return RestClient.deleteRequest(Workspace_EndPoints.roles + `/${roleId}`, header, setFormLoading, null, null, true)
  }

  static getSettings (header) {
    return RestClient.getRequest(Workspace_EndPoints.settings, header, true)
  }

  static updateSetting (settingId, data, header, setFormLoading) {
    return RestClient.patchRequest(Workspace_EndPoints.settings + `/${settingId}`, data, header, setFormLoading, null, null, true)
  }

  static addNewAdmin (data, header, setFormLoading, setFailure, FormikActions) {
    return RestClient.postRequest(Workspace_EndPoints.addAdmin, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static getCurrencies (header) {
    return RestClient.getRequest(Workspace_EndPoints.currencies, header, true)
  }

  static getCurrency (currencyId, header) {
    return RestClient.getRequest(`${Workspace_EndPoints.currencies}/${currencyId}`, header, true)
  }

  static submitCurrency (currencyId, isEdit, data, header, setFormLoading, setFailure, FormikActions) {
    return !!isEdit
      ? RestClient.putRequest(`${Workspace_EndPoints.currencies}/${currencyId}`, data, header, setFormLoading, setFailure, FormikActions, true)
      : RestClient.postRequest(Workspace_EndPoints.currencies, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static deleteCurrency (currencyId, header, setFormLoading) {
    return RestClient.deleteRequest(`${Workspace_EndPoints.currencies}/${currencyId}`, header, setFormLoading, null, null, true)
  }

  static getPages (header) {
    return RestClient.getRequest(Workspace_EndPoints.pages, header, true)
  }

  static updatePage (pageId, data, header, setFormLoading, setFailure, FormikActions) {
    return RestClient.putRequest(Workspace_EndPoints.pages + `/${pageId}`, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static getPageData (pageId, header) {
    return RestClient.getRequest(Workspace_EndPoints.pages + `/${pageId}`, header, true)
  }

  static submitPage (pageId, isEdit, data, header, setFormLoading, setFailure, FormikActions) {
    return !!isEdit ? RestClient.putRequest(Workspace_EndPoints.pages + `/${pageId}`, data, header, setFormLoading, setFailure, FormikActions, true)
      : RestClient.postRequest(Workspace_EndPoints.pages, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static deletePage (pageId, header, setFormLoading) {
    return RestClient.deleteRequest(Workspace_EndPoints.pages + `/${pageId}`, header, setFormLoading, null, null, true)
  }

  static getCompanies (header) {
    return RestClient.getRequest(Workspace_EndPoints.companies, header, true)
  }

  static exportCompanies (header) {
    return RestClient.getRequest(Workspace_EndPoints.exportCompanies, header, true)
  }

  static activateDeactivateCompany (cid, data, header, setFormLoading) {
    return RestClient.putRequest(Workspace_EndPoints.companies + `/${cid}`, data, header, setFormLoading, null, null, true)
  }

  static deleteCompany (companyId, header, setFormLoading) {
    return RestClient.deleteRequest(Workspace_EndPoints.companies + `/${companyId}`, header, setFormLoading, null, null, true)
  }

  static updateCompanySubscription (companyId, data, header, setFormLoading, FormikActions) {
    return RestClient.patchRequest(Workspace_EndPoints.companies + `/${companyId}/subscription`, data, header, setFormLoading, null, FormikActions, true)
  }

  static getCompanyUsers (cid, header) {
    return RestClient.getRequest(Workspace_EndPoints.companies + `/${cid}/user`, header, true)
  }

  static importUPTCPFile (data, header, setFormLoading, FormikActions) {
    return RestClient.postRequest(Workspace_EndPoints.importUPTCP, data, header, setFormLoading, null, FormikActions, true)
  }

}

export default UserServices
